import { useEffect } from 'react'
import { EmitterSubscription, Platform } from 'react-native'
import { isProduction } from '@/utils/environment'
import { getPublicKeyConfig } from '@/config/appConfig'

const getPublicKey = () => {
  const publicKeyConfig = getPublicKeyConfig()
  const { development, production } = publicKeyConfig
  return isProduction() ? production : development
}

export const useSslPinning = () => {
  const { dominio, key } = getPublicKey()

  useEffect(() => {
    let sub: EmitterSubscription | null = null

    if (Platform.OS !== 'web') {
      const initialize = async () => {
        const { initializeSslPinning, addSslPinningErrorListener } = await import(
          'react-native-ssl-public-key-pinning'
        )

        const config = {
          [dominio]: {
            includeSubdomains: true,
            publicKeyHashes: [key],
          },
        }

        console.log('[SSL Pinning] Configurando:', JSON.stringify(config))

        initializeSslPinning(config)
          .then(() => {
            console.log('[SSL Pinning] Inicializado correctamente')
            console.log('[SSL Pinning] Dominio:', dominio)
            console.log('[SSL Pinning] Hash configurado:', key)
          })
          .catch((err) => {
            console.error('[SSL Pinning] Error al inicializar:', err)
          })

        sub = addSslPinningErrorListener((error) => {
          console.error('[SSL Pinning] Fallo de pinning:', error.message)
          console.error('[SSL Pinning] Host rechazado:', JSON.stringify(error))
        })
      }
      initialize()
    }

    return () => {
      if (sub) {
        sub.remove()
      }
    }
  }, [])
}
